import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import ProjectsTable from './ProjectsTable';
import ProjectCreate from './ProjectCreate';

export default function ProjectsManagement() {
  const [reloadKey, setReloadKey] = useState(0);
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <div>
      <ProjectsTable
        reloadKey={reloadKey}
        onReload={() => setReloadKey(k => k + 1)}
        onCreate={() => setShowCreateModal(true)}
      />

      {showCreateModal && createPortal(
        <div className="eduss-global-modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="eduss-global-modal large eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
            <div className="eduss-global-modal-header">
              <h3>Create New Project</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <ProjectCreate
                onClose={() => setShowCreateModal(false)}
                onSubmit={() => { setReloadKey(k => k + 1); setShowCreateModal(false); }}
              />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}
